/*
  Ballr — Real videos.

  Carousel arrows, a play/pause button per reel, play/pause as each reel scrolls in and out
  of view, and a sound toggle.
  Videos are muted so browsers allow autoplay; the first tap on the speaker turns sound on.

  Scroll is tweened by hand with a timer backstop, for the same reason as the cart carousel:
  requestAnimationFrame does not fire in a background tab and native smooth scrolling is
  unreliable inside transformed containers.
*/
(function () {
  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function initCarousel(root) {
    var list = root.querySelector('.ballr-reels__list');
    var prev = root.querySelector('[data-ballr-reels-prev]');
    var next = root.querySelector('[data-ballr-reels-next]');
    if (!list || !prev || !next) return;

    function step() {
      var item = list.querySelector('.ballr-reels__item');
      if (!item) return list.clientWidth;
      var styles = getComputedStyle(list);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return Math.round(item.getBoundingClientRect().width + gap);
    }

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      root.classList.toggle('ballr-reels--has-nav', max > 1);
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= max - 1;
    }

    function scrollBySteps(direction) {
      var max = list.scrollWidth - list.clientWidth;
      var from = list.scrollLeft;
      var to = Math.max(0, Math.min(max, from + step() * direction));
      if (Math.abs(to - from) < 1) return;

      var duration = 320;
      var startedAt = null;
      var painted = false;
      var done = false;

      list.style.scrollSnapType = 'none';

      function finish() {
        if (done) return;
        done = true;
        list.scrollLeft = to;
        list.style.scrollSnapType = '';
        update();
      }

      function frame(now) {
        if (done) return;
        if (startedAt === null) startedAt = now;
        painted = true;
        var p = Math.min(1, (now - startedAt) / duration);
        list.scrollLeft = from + (to - from) * (0.5 - Math.cos(Math.PI * p) / 2);
        if (p < 1) requestAnimationFrame(frame);
        else finish();
      }

      requestAnimationFrame(frame);
      setTimeout(function () {
        if (!painted) finish();
      }, 120);
      setTimeout(finish, duration + 250);
    }

    prev.addEventListener('click', function () {
      scrollBySteps(-1);
    });
    next.addEventListener('click', function () {
      scrollBySteps(1);
    });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
    setTimeout(update, 400);
  }

  function initVideos(root) {
    var autoplay = root.dataset.autoplay !== 'false';
    var videos = root.querySelectorAll('.ballr-reels__video');

    function toggle(video) {
      if (video.paused) {
        if (video.preload === 'none') video.preload = 'auto';
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    }

    each(videos, function (video) {
      var frame = video.closest('.ballr-reels__frame');
      var button = frame ? frame.querySelector('[data-ballr-reels-play]') : null;

      /* The button label and the play/pause icons follow the video's own events,
         so autoplay-on-scroll and a tap on the video keep them in sync too. */
      function sync() {
        if (frame) frame.classList.toggle('is-playing', !video.paused);
        if (button) button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      }

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();

      // Tap the video itself to pause or resume.
      video.addEventListener('click', function () {
        toggle(video);
      });

      if (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          toggle(video);
        });
      }
    });

    var sounds = root.querySelectorAll('[data-ballr-reels-sound]');
    each(sounds, function (button) {
      button.addEventListener('click', function () {
        var frame = button.closest('.ballr-reels__frame');
        var video = frame.querySelector('.ballr-reels__video');
        if (!video) return;

        if (video.muted) {
          // Only one reel makes noise at a time.
          each(root.querySelectorAll('.ballr-reels__video'), function (other) {
            if (other !== video) {
              other.muted = true;
              var otherFrame = other.closest('.ballr-reels__frame');
              if (otherFrame) otherFrame.classList.remove('is-unmuted');
            }
          });
          video.muted = false;
          frame.classList.add('is-unmuted');
          video.play().catch(function () {});
        } else {
          video.muted = true;
          frame.classList.remove('is-unmuted');
        }
      });
    });

    if (!autoplay || !('IntersectionObserver' in window)) return;

    // Load and play only what is on screen; pause and unload the rest.
    var observer = new IntersectionObserver(
      function (entries) {
        each(entries, function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'auto';
            video.play().catch(function () {});
          } else {
            video.pause();
            video.muted = true;
            var frame = video.closest('.ballr-reels__frame');
            if (frame) frame.classList.remove('is-unmuted');
          }
        });
      },
      { threshold: 0.4 }
    );

    each(videos, function (video) {
      observer.observe(video);
    });
  }

  function init() {
    each(document.querySelectorAll('[data-ballr-reels]'), function (root) {
      if (root.dataset.ballrReelsReady === 'true') return;
      root.dataset.ballrReelsReady = 'true';
      initCarousel(root);
      initVideos(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section.
  document.addEventListener('shopify:section:load', init);
})();
